import Icon, { IconName } from '@features/ui-atoms/components/Icon';
import Button, { ButtonProps, ButtonVariants } from '@features/ui-form/components/Button';
import { useTranslation } from 'next-i18next';

export const ClearFiltersButton = ({
  variant = ButtonVariants.SECONDARY,
  ...rest
}: Omit<ButtonProps, 'label' | 'startDecorator'>) => {
  const { t } = useTranslation('common');
  return (
    <Button
      variant={variant}
      startDecorator={<Icon name={IconName.close} />}
      label={t('action.resetSearch')}
      {...rest}
    />
  );
};
